module.exports = __webpack_public_path__ + "media/country_flags/at-78f52a66.png";